import type { PluginItem } from "@babel/core";

//
// Parser plugins for @babel/parser (used with packages.parser.parse)
// These are string-based plugin names, not transform plugins
//
export const standardParserPlugins: Array<string | [string, Record<string, unknown>]> = [
	"jsx",
	["typescript", { isTSX: true }],
];

//
// Transform plugins/presets for @babel/standalone's transform functions
// @babel/standalone has built-in presets that we can reference by name
//
export const standardTransformPresets: PluginItem[] = [
	["typescript", { isTSX: true, allExtensions: true }],
	"react",
];

// Legacy async function for compatibility during migration
// Returns transform presets (used with transformFromAstAsync)
export const getStandardTransformPresets = async (): Promise<PluginItem[]> => {
	return standardTransformPresets;
};
